// NumberField.jsx
import { TextField } from "@mui/material";
import { formatTitle } from "../utils";

export const NumberField = ({
  fieldKey,
  schema,
  value,
  required,
  onChange,
}) => {
  return (
    <TextField
      fullWidth
      type="number"
      label={schema?.title || formatTitle(fieldKey)}
      placeholder={schema.description}
      value={value ?? ""}
      onChange={(e) => {
        const val = e.target.value;
        onChange(val === "" ? null : parseFloat(val));
      }}
      required={required}
      sx={{
        "& .MuiOutlinedInput-root.Mui-focused fieldset": {
          borderColor: "primary.main",
        },
      }}
    />
  );
};
